export const AMOUNT_HINT_ATTRIBUTE = "data-amount-hint"
